module.exports = __webpack_public_path__ + "img/logo.d5b860b2.svg";